(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-video')) {
    customElements.define(
      'hero-video',
      class HeroVideo extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;

          this.button = this.querySelector('.hv__sound');
          this.bar = this.querySelector('.hv__progress span');
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          // Respect reduced motion: show the poster, play only when the visitor asks.
          if (this.reduceMotion) {
            this.video.removeAttribute('autoplay');
            this.video.pause();
          }

          if (this.button) {
            this.onToggle = () => this.toggleSound();
            this.button.addEventListener('click', this.onToggle);
          }

          this.onTime = () => {
            if (this.bar && this.video.duration) {
              this.bar.style.width = (this.video.currentTime / this.video.duration) * 100 + '%';
            }
          };
          this.video.addEventListener('timeupdate', this.onTime);

          // Pause while off screen to save battery and bandwidth.
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              ([entry]) => {
                if (entry.isIntersecting) {
                  if (!this.reduceMotion || !this.video.muted) this.video.play().catch(() => {});
                } else {
                  this.video.pause();
                }
              },
              { threshold: 0.25 }
            );
            this.observer.observe(this);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.button && this.onToggle) this.button.removeEventListener('click', this.onToggle);
          if (this.video && this.onTime) this.video.removeEventListener('timeupdate', this.onTime);
        }

        toggleSound() {
          const video = this.video;
          video.muted = !video.muted;
          if (!video.muted) video.play().catch(() => {});

          const soundOn = !video.muted;
          this.button.setAttribute('aria-pressed', String(soundOn));
          const label = this.button.querySelector('.hv__sound-label');
          if (label) {
            label.textContent = soundOn ? this.button.dataset.labelOn : this.button.dataset.labelOff;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
